import { Link } from '@tanstack/react-router';
import { Card, Eyebrow, IconTile, PageHeader } from '@/shared/components';
import { useAuth } from '@/shared/auth';
import { I } from '@/shared/icons';
import { settingsNavigation } from './settingsNavigation';
import { isSettingsItemVisible } from './settingsVisibility';

/**
 * Einstellungen-Hub-Übersicht (`/settings`). Landing des Haupt-Nav-Eintrags
 * „Einstellungen" — gruppiert Organisation, Abrechnung, Integrationen und System als
 * einstiegsfreundliche Kacheln. Rendert nur sichtbare Einträge (`isSettingsItemVisible`).
 */
export function SettingsHubPage() {
  const { user } = useAuth();

  return (
    <>
      {/* Vorher `title="Ein"` plus `titleAccent="stellungen"`. `PageHeader` setzt zwischen beiden
          ein Leerzeichen — auf der Seite stand „Ein stellungen.", ein mitten im Wort getrenntes
          Wort. Derselbe Befund wie bei den Bindestrich-Titeln in D2. */}
      <PageHeader
        eyebrow="Verwaltung"
        title="Alle"
        titleAccent="Einstellungen"
        description="Organisation, Abrechnung, Integrationen sowie System und Sicherheit — getrennt vom Tagesgeschäft."
      />

      <div className="flex flex-col gap-8">
        {settingsNavigation.map((group) => {
          const visibleItems = group.items.filter((item) => isSettingsItemVisible(user, item));
          if (visibleItems.length === 0) return null;
          return (
            <section key={group.label}>
              <Eyebrow variant="muted" className="mb-3">
                {group.label}
              </Eyebrow>
              <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-3">
                {visibleItems.map((item) => (
                  <Link
                    key={item.to}
                    to={item.to}
                    className="focus-visible:ring-sage rounded-lg focus-visible:outline-none focus-visible:ring-2"
                  >
                    <Card className="hover:bg-card-alt h-full transition-colors">
                      <div className="flex items-start gap-3 p-5">
                        <IconTile variant="navy" size="md">
                          <I name={item.icon} size={18} strokeWidth={2} aria-hidden />
                        </IconTile>
                        <div className="min-w-0">
                          <h3 className="text-ink font-serif text-lg leading-tight">
                            {item.label}
                          </h3>
                          <p className="text-ink-soft mt-1 text-sm">{item.description}</p>
                        </div>
                      </div>
                    </Card>
                  </Link>
                ))}
              </div>
            </section>
          );
        })}
      </div>
    </>
  );
}
